var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutFullScreen',{attrs:{"height-offset":60}},[_c('PriceIndex',{attrs:{"kitId":_vm.selectedSetId}}),_c('RealtimeSystemMap')],1)}
var staticRenderFns = []

export { render, staticRenderFns }